import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navigation from '../components/Navigation';
import base_url from '../config/Config';
import axios from 'axios';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';


const CreditReport = () => {
    const [, setCustomer] = useState(null);
    const [, setLoan] = useState([]);
    const [partnerLoanId, setPartnerLoanId] = useState(null);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const id = params.get('id');

    // const id = queryParams.get('id');
    const [pdfUrl, setPdfUrl] = useState(null);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    useEffect(() => {
        const fetchPdf = async () => {
            try {
                const response = await fetch(`${base_url}/api1/cibil/download-pdf?customerId=${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/pdf',
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to load PDF');
                }

                const blob = await response.blob();
                const url = window.URL.createObjectURL(new Blob([blob]));
                setPdfUrl(url);
            } catch (error) {
                console.error('Error loading PDF:', error);
            }
        };

        fetchPdf();
    }, [id]);    
  

    useEffect(() => {
        const getOneCustomer = async () => {
            try {
                const response = await axios.get(`${base_url}/api1/account/verifiedCustomerById`, { params: { id } });
                console.log(response.data);
                setCustomer([response.data]); // Store customer data
                
                // Ensure partnerLoanId is set for subsequent use
                const partnerLoanIdFromAPI = response.data.partnerLoanId;
                setPartnerLoanId(partnerLoanIdFromAPI);
            } catch (error) {
                console.error("Error fetching Customer data:", error);
            }
        };

        if (id) {
            getOneCustomer();
        }
    }, [id]);

    // State for storing partnerLoanId
    // Fetch loan details using partnerLoanId
    useEffect(() => {
        if (partnerLoanId) {
            const getOneLoan = async () => {
                try {
                    const response = await axios.get(`${base_url}/api1/customer/disbursedByCustomerId`, {
                        params: { id, partnerLoanId }
                    });
                    console.log(response.data);
                    setLoan([response.data]);
                } catch (error) {
                    console.error("Error fetching Loan data:", error);
                }
            };

            getOneLoan();
        }
    }, [id, partnerLoanId]);

    return (
        <>
            <div className='overviewsaa'>
                <h4>Credit Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                    <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='reportsanalyzier mb-3'>
                                        <div className='row'>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='credit buttonandly'>
                                                    {/* <span onClick={cibilReportPDF}><p>Credit Report</p></span> */}
                                                    <NavLink to={`/headerfile/CreditReport?id=${id}`}><p>Credit Report</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-3'>
                                                <div className='analyzier buttonandly'>
                                                    <NavLink to={`/headerfile/LoanAgreement?id=${id}`}><p>Loan Agreement</p></NavLink>
                                                </div>
                                            </div>
                                            {/* <div className='col-lg-2 col-md-2'>
                                                <div className='digitalfoot buttonandly'>
                                                    <NavLink to={`/headerfile/LoanProduct?id=${id}`}><p>Loan Product</p></NavLink>
                                                </div>
                                            </div> */}
                                            <div className='col-lg-2 col-md-3'>
                                                <div className='devicehistory buttonandly'>
                                                 <NavLink to={`/loanmaster/LoanList?customerId=${id}`}> <p>Loan Details</p></NavLink>                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='location buttonandly'>
                                                    <NavLink to={`/operation/ViewVerifiedCustomer?id=${id}`}><p>Customer View</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='location buttonandly'>
                                                    <NavLink to={`/document/LoanDocuments?customerId=${id}`}> <p>Document</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='businessverification buttonandly'>
                                                    <NavLink to={`/headerfile/NOC?id=${id}`}><p>NOC</p></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                        <div className='pdfurl mt-3 mb-3'>
                        {pdfUrl ? (
                            <Worker workerUrl={pdfjsWorker}>
                                <div
                                    style={{
                                        border: '1px solid rgba(0, 0, 0, 0.3)',
                                        height: '750px',
                                    }}
                                >
                                    <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                                </div>
                            </Worker>
                        ) : (
                            <p>Loading PDF...</p>
                        )}
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div>
            </div>
        </>
    );
};

export default CreditReport;
